// extracted by mini-css-extract-plugin
module.exports = {"projectListContainer":"ProjectList_projectListContainer__2Dpq5","imageContainer":"ProjectList_imageContainer__2dkC0","image":"ProjectList_image__1N9SZ"};